var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.594 0H1.406C1.19 0 .987.048.804.127l7.165 6.467 1.606-1.393L15.196.127A1.514 1.514 0 0014.594 0zm1.266.726L10.57 5.5l5.29 4.774a1.16 1.16 0 00.14-.543V1.269a1.16 1.16 0 00-.14-.543zM.14.725A1.18 1.18 0 000 1.27v8.462c0 .195.053.378.14.543L5.43 5.5.14.725z","key":0}),React.createElement("path",{"d":"M9.906 6.098L8.3 7.491a.494.494 0 01-.331.124.494.494 0 01-.332-.124L6.094 6.098l-5.29 4.775c.183.079.386.127.602.127h13.188c.216 0 .419-.048.602-.127l-5.29-4.775z","key":1})]);
}

Mail.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 11"};

module.exports = Mail;

Mail.default = Mail;
